import type { KpiRefreshTickPayload } from '../servicebus/kpi';
import { ObjectFactory } from './object.factory';

export class KpiRefreshTickPayloadFactory extends ObjectFactory<KpiRefreshTickPayload> {
  protected getDefaults(): KpiRefreshTickPayload {
    return { generation: 1 };
  }
}

// Pre-instantiated for convenience
export const kpiRefreshTickPayloadFactory = new KpiRefreshTickPayloadFactory();
